<template>
    <div class="field">
        <div class="control has-icons-left">
            <input v-model="brand"
                   v-bind:class="{ 'is-danger': error && error.length > 0 }"
                   class="input"
                   type="text"
                   placeholder="Type Brand">
            <span class="icon is-small is-left">
                <i class="fas fa-cogs"></i>
            </span>
            <p v-if="error && error.length > 0" class="help is-danger">{{ error[0] }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            brand: {
                get: function () {
                    return this.$store.getters.getNewCarBrand
                },
                set: function (value) {
                    this.$store.dispatch('setNewCarBrand', value)
                }
            },
            error: {
                get: function () {
                    return this.$store.getters.getNewCarErrorBrand
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/Inputs/BrandInput.vue